import { Browser } from '$constants'
import { useEffect, useState } from 'react'

export const useBrowserDetection = (): Browser => {
  const [browser, setBrowser] = useState<Browser>(Browser.Unknown)

  useEffect(() => {
    const userAgent = navigator.userAgent

    if (userAgent.includes('Chrome')) {
      setBrowser(Browser.Chrome)
    } else if (userAgent.includes('Firefox')) {
      setBrowser(Browser.Firefox)
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      setBrowser(Browser.Safari)
    } else if (userAgent.includes('Edge')) {
      setBrowser(Browser.Edge)
    } else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
      setBrowser(Browser.InternetExplorer)
    } else {
      setBrowser(Browser.Unknown)
    }
  }, [])

  return browser
}
